export { default } from './ReportcenterWidgetLegend';
